import React, { useState, useEffect, FunctionComponent } from 'react';
import { Presentation } from './presentation';
import type { TvDetail } from '../../../types/tvShow';
import { getTvDetail } from '../../../services/tvs';

type Props = {
  tvId: number;
  currentUser: boolean;
  lineIcon: string;
};

export const Component: FunctionComponent<Props> = ({
  tvId,
  currentUser,
  lineIcon
}) => {
  const [tv, setTv] = useState<TvDetail | null>(null);

  useEffect(() => {
    const fetchTv = async () => {
      try {
        const response = await getTvDetail(tvId);
        setTv(response);
      } catch (error) {
        console.log(error);
      }
    };
    fetchTv();
  }, [tvId]);

  return (
    <Presentation
      tv={tv}
      currentUser={currentUser}
      lineIcon={lineIcon}
    />
  );
};
